export default __webpack_public_path__ + "static/media/icon-app-store.621b45d8.svg";